<app-breadcrumb [master]="'Rejestracje'" [parentName]="'Wyrejestrowania'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-deregistration-pack-add *ngIf="modify" (closeModification)="modify = false; loadDeregistrationPack()" [deregistrationPack]="deregistrationPack"></app-deregistration-pack-add>
    <app-deregistration-pack-details-view *ngIf="!modify" [deregistrationPack]="deregistrationPack" (modifyClicked)="modify = true"></app-deregistration-pack-details-view>
  </mat-tab>
  <mat-tab label="Do wyrejestrowania">
    <ng-template matTabContent>
      <app-all-registrations-list
        [disableBreadcrumb]="true" [disableFilters]="true" [statusKeys]="[REGISTRATION_STATUS_TO_DEREGISTER]"
        [agreedToDeregister]="true" [insuranceCompanyId]="deregistrationPackObject.insuranceCompany.id"
        [companyId]="deregistrationPackObject.company.id" [haveDeregistrationPack]="true" [showAddToPackAction]="true"
        [deregistrationPackUuid]="deregistrationPackObject.uuid" [embeddedView]="true"
        [displayColumns]="['select', 'name','ofwca','ofwcaLastName', 'rauNumber', 'status', 'agreedToDeregister', 'company', 'partner', 'assetsRegional']"
      ></app-all-registrations-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Rejestracje">
    <ng-template matTabContent>
<!--      <button [disabled]="!(userPermissions | async).deregistration.write || deregistrationPackObject.status.key === DEREGISTRATION_PACK_STATUS_SENT"-->
<!--              mat-stroked-button color="primary" class="add-button" (click)="addRegistration()"><mat-icon>add</mat-icon> Dodaj rejestrację</button>-->

      <app-all-registrations-list
        [disableBreadcrumb]="true" [disableFilters]="true" [deregistrationPack]="deregistrationPackId"
        [excludeColumns]="['ofwca_just', 'insuranceCompany_just','insuranceCompany', 'insuranceCompanyType', 'passedExam100p', 'statements',
        'activeKrk', 'signedUpForAnExam', 'examPassed', 'passedExam40p', 'sentToRegister', 'missingExam', 'deregistrationPack',
        ]" [reloadList]="reloadRegistrations" [deregistrationPackObject]="deregistrationPackObject" [embeddedView]="true"
      ></app-all-registrations-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [deregistrationPack]="deregistrationPack"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
